module.exports = __webpack_public_path__ + "img/graph_sales.a45413b9.png";